import * as _types2 from "@babel/types";
var _types = "default" in _types2 ? _types2.default : _types2;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createUnionType = createUnionType;
  var _t = _types;
  const {
    createFlowUnionType,
    createTSUnionType,
    createUnionTypeAnnotation,
    isFlowType,
    isTSType
  } = _t;
  function createUnionType(types) {
    {
      if (isFlowType(types[0])) {
        if (createFlowUnionType) {
          return createFlowUnionType(types);
        }
        return createUnionTypeAnnotation(types);
      } else {
        if (createTSUnionType) {
          return createTSUnionType(types);
        }
      }
    }
  }

  //# sourceMappingURL=util.js.map
  return exports;
}